import { Injectable } from '@angular/core';
import { SipProvider } from './sip/sip';
import { PatientDataProvider } from './patient-data/patient-data';
import { DbProvider } from './db/db';
import {Events} from './events';

export class ChatMessage {
  messageId: string;
  userId: string;
  userName: string;
  userAvatar: string;
  toUserId: string;
  time: number | string;
  message: string;
  status: string;
  _id?: string;
  _rev?: string;
}

export class UserInfo {
  id: string;
  name?: string;
  avatar?: string;
}

@Injectable()
export class ChatService {

  constructor(
    private events: Events, private sipProvider: SipProvider, private dbProvider: DbProvider, private patientDataProvider: PatientDataProvider) {

    this.sipProvider.events.destroy('onNewMessage');
    this.sipProvider.events.subscribe('onNewMessage', (ev: any) => {
      this.incomingMessage(ev);
    });
  }

  async incomingMessage(ev) {
    let userName = 'Unbekannt';
    const contacts = await this.patientDataProvider.getContacts();
    const find = contacts.filter((contact) => {
      return contact.code === ev.message._request.from._uri._user;
    });

    if (find.length) {
      userName = find[0].firstname + ' ' + find[0].lastname;
    }

    const msg: ChatMessage = {
      messageId: Date.now().toString(),
      userId: ev.message._request.from._uri._user,
      userName,
      userAvatar: './assets/img/avatar.png',
      toUserId: this.sipProvider.inputReady,
      time: Date.now(),
      message: ev.message._request.body,
      status: 'success'
    };

    this.dbProvider.put(msg, msg.toUserId + '-' + msg.messageId).then(() => {
    this.events.publish('chat:received', msg);
    }).catch((err: any) => {
      console.log(err);
    });
  }

  mockNewMsg(msg) {
    const mockMsg: ChatMessage = {
      messageId: Date.now().toString(),
      userId: 'userId',
      userName: 'Max Mustermann',
      userAvatar: './assets/img/avatar.png',
      toUserId: 'mockId',
      time: Date.now(),
      message: msg.message,
      status: 'success'
    };

    setTimeout(() => {
      this.events.publish('chat:received', mockMsg);
    }, Math.random() * 1800);
  }

  getMsgList(toUser): Promise<ChatMessage[]> {
    // const msgListUrl = './assets/mock/msg-list.json';

    return this.dbProvider.findChatData(this.sipProvider.inputReady, toUser).then((res: any) => {
      return Promise.resolve(res.docs);
    });

  }

  sendMsg(msg: ChatMessage) {
    return new Promise((resolve, reject) => {

      this.dbProvider.put(msg, msg.toUserId + '-' + msg.messageId).then((dbRes: any) => {

        msg._id = dbRes.id;
        msg._rev = dbRes.rev;

        this.sipProvider.sendMessage(msg.toUserId, msg.message).then(async (res: any) => {
          if (res.originator === 'remote') {
            if (res.response.method === 'MESSAGE' && res.response.status_code === 202) {
              // Nachricht ist angekommen
              msg.status = 'success';
              try {
                await this.dbProvider.put(msg);
              } catch (error) {
                console.log(error);
              }
              
            }
          }
          resolve(msg);

        });
      }).catch((e: any) => {
        reject(e);
      });
    });
    /*
    return new Promise(resolve => setTimeout(() => resolve(msg), Math.random() * 1000))
    .then(() => this.mockNewMsg(msg));
    */
  }

  getUserInfo(): Promise<UserInfo> {
    // Mein User
    const addr = this.patientDataProvider.api._user.profile;

    const userInfo: UserInfo = {
      id: this.sipProvider.inputReady,
      name: addr.firstname + ' ' + addr.lastname,
      avatar: './assets/img/avatar.png'
    };
    return new Promise(resolve => resolve(userInfo));
  }

}
